import React from 'react';

export function Card({ children, className = '' }) {
  return <div className={`ds-card ${className}`.trim()}>{children}</div>;
}

export function CardContent({ children, className = '' }) {
  return <div className={`ds-card__body ${className}`.trim()}>{children}</div>;
}

export default Card;
